module.exports = __webpack_public_path__ + "img/bsh_web.35bc6556.png";